<script setup lang="ts">
/** Indicateur d'attente discret. Hérite de la couleur du texte. */
withDefaults(defineProps<{ size?: 16 | 20 | 24; label?: string }>(), {
  size: 20,
  label: undefined,
})
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    class="shrink-0 animate-spin motion-reduce:animate-none"
    :role="label ? 'status' : undefined"
    :aria-label="label"
    :aria-hidden="label ? undefined : 'true'"
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.2" stroke-width="2" />
    <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
